// extracted by mini-css-extract-plugin
export default {"avatars":"_2oMAF7iRRUnLpIWmjwN9kADK4Y3ZPeZIZXnOFKjy3co=","avatar":"KuFpHpYAxH4p+gtj8Y8lSvdFXw2AWLXLsKLwZsp8xc8="};